// extracted by mini-css-extract-plugin
export default {"container":"pMq92R47w9MzUFk3pT9d","title":"_mMTCnvnOX9REbTsnckK","close":"RfelskfMK8kgE3uZofZk"};